/* On PDP for a product, RelatedServiceSellingPlanRadios creates an 
add subscription option for a secondary service */
class RelatedServiceSellingPlanRadios extends HTMLElement {
  constructor() {
    super();
    this.data = this.getData();
    this.elements = this.getElements();
    this.setupEventListeners();
    const url = new URL(window.location.href);
    const related_selling_plan_param = this.elements.selectedRadioEl.checked
      ? this.elements.selectedRadioEl.dataset.relatedSpId
      : url.searchParams.get('related_selling_plan');
    if (related_selling_plan_param) this.related_selling_plan = related_selling_plan_param;
    this.current_variant = url.searchParams.get('variant');
    this.updateServiceSellingPlanVariant();
    this.updateURL();
    this.setInitialVariantState();
    this.toggleSellingPlans();
  }

  setupEventListeners() {
    this.elements.radiosEl.forEach((element) => {
      element.addEventListener('click', this.handleSetValueAndLabel.bind(this));
    });
    this.elements.selectedRadioEl.addEventListener('change', (event) => this.handleRadioADA(event));
  }

  handleRadioADA(event) {
    const { key, currentTarget } = event;
    if (key === 'Enter') {
      currentTarget.checked = !currentTarget.checked;
      this.toggleDisplaySellingPlans();
    }
  }

  handleSetValueAndLabel({ currentTarget }) {
    this.related_selling_plan = this.elements.selectedRadioEl.checked ? currentTarget.dataset.relatedSpId : '';
    this.updateURL();
  }

  getData() {
    return {
      json: JSON.parse(this.querySelector('[data-related-sp-json]').textContent)
    };
  }

  getElements() {
    return {
      radiosEl: this.querySelectorAll('[data-related-selling-plans-radio]'),
      selectedRadioEl: this.querySelector('[data-related-selling-plans-radio]'),
      variantRadios: document.querySelector('variant-radios')
    };
  }

  setInitialVariantState() {
    if (this.related_selling_plan) this.elements.selectedRadioEl.checked = true;
    const current_variant = parseInt(this.dataset.currentVariant);
    const current_data = this.data.json[current_variant] || {};
    const { related_sp_variant, related_display_variant, related_sp_variant_plan_id } = current_data;
    const { id } = related_sp_variant || {};

    this.elements.selectedRadioEl.dataset.relatedSpId = id;
    this.elements.selectedRadioEl.value = related_sp_variant_plan_id;
  }

  updateServiceSellingPlanVariant() {
    if (this.current_variant && this.related_selling_plan) {
      this.elements.selectedRadioEl.dataset.relatedSpId = this.data.json[this.current_variant].id;
    }
  }

  toggleSellingPlans() {
    if (this.elements.selectedRadioEl.checked) {
      this.related_selling_plan = this.elements.selectedRadioEl.dataset.relatedSpId;
      this.updateURL();
    } else if (!this.elements.selectedRadioEl.checked) {
      this.related_selling_plan = '';
      this.updateURL();
    }
  }

  handleOnVariantChange() {
    const url = new URL(window.location.href);
    const current_variant = url.searchParams.get('variant');
    if (current_variant) {
      const current_data = this.data.json[current_variant] || {};
      const { related_sp_variant, related_display_variant, related_sp_variant_plan_id } = current_data;
      const { id } = related_sp_variant || {};

      if (this.elements.selectedRadioEl.checked) {
        this.elements.selectedRadioEl.dataset.relatedSpId = id;
        this.elements.selectedRadioEl.value = related_sp_variant_plan_id;
      } else this.elements.selectedRadioEl.dataset.relatedSpId = '';
    }
  }

  updateURL() {
    if (this.related_selling_plan == null) return; // covers null and undefined
    const url = new URL(window.location.href);
    url.searchParams.set('related_selling_plan', this.related_selling_plan);

    // window.location
    window.history.replaceState({}, '', url.href);

    // share button
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(url.href);
  }
}

customElements.define('related-service-selling-plan-radios', RelatedServiceSellingPlanRadios);
